import React from 'react'
import useSnackbar from 'hooks/useSnackbar'

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
} from '@material-ui/core'
import helpers from 'helpers'

import ModalSuccess from 'components/ModalSuccess'

import * as service from 'service'
import { useParams } from 'react-router-dom'

const ContractsDialogSetPenalty = ({
  open,
  setOpen,
  penalty,
  setPenaltyId,
}) => {
  const [openModal, setOpenModal] = React.useState(false)
  const [contractPenaltyId, setContractPenaltyId] = React.useState()
  const snackbar = useSnackbar()
  const params = useParams()
  const contractId = params.contractId

  const onConfirm = async () => {
    try {
      const response = await service.recurrence.contracts.activePenalty({
        contractId,
      })
      setContractPenaltyId(response?.data?.contract?.penaltyId)
      setOpen(false)
      setOpenModal(true)
    } catch {
      snackbar.open({
        message: 'Falha ao atualizar juros e multa!',
        variant: 'error',
      })
    } finally {
      setOpen(false)
    }
  }

  const handleClose = () => {
    setOpenModal(false)
    setPenaltyId(contractPenaltyId)
  }

  return (
    <>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle id="form-dialog-title">
          <Box mt={1}>
            <Typography variant="h3">Atualizar juros e multa</Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography component="div" color="textSecondary">
            Deseja realmente atualizar o percentual de juros e taxa de multa
            desta assinatura para os valores de configuração atual abaixo?
            <Box mt={2}>
              Juros ao mês:{' '}
              <Box component="span" fontWeight="fontWeightBold" mr={3}>
                {`${penalty?.interestRate}%`}
              </Box>
              Taxa de multa:{' '}
              <Box component="span" fontWeight="fontWeightBold">
                {penalty
                  ? penalty?.fineValue
                    ? helpers.currency(penalty?.fineValue)
                    : `${penalty?.finePercentage}%`
                  : '0'}
              </Box>
              .
            </Box>
          </Typography>
        </DialogContent>

        <Box p={1}>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              form="manual-confirmation-form"
              onClick={onConfirm}
            >
              Atualizar
            </Button>
            <Button
              onClick={() => setOpen(false)}
              variant="outlined"
              color="primary"
            >
              Cancelar
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
      <ModalSuccess open={openModal} onClose={handleClose}>
        Juros e multa atualizados!
      </ModalSuccess>
    </>
  )
}

export default ContractsDialogSetPenalty
